import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English', short: 'EN', flag: '🇺🇸' },
  { code: 'es', label: 'Español', short: 'ES', flag: '🇪🇸' },
  { code: 'it', label: 'Italiano', short: 'IT', flag: '🇮🇹' },
  { code: 'de', label: 'Deutsch', short: 'DE', flag: '🇩🇪' },
  { code: 'pt', label: 'Português', short: 'PT', flag: '🇵🇹' },
  { code: 'zh', label: '中文', short: 'ZH', flag: '🇨🇳' },
  { code: 'ja', label: '日本語', short: 'JA', flag: '🇯🇵' },
];

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentCode = (i18n.language?.split('-')[0] || 'es').toLowerCase();
  const currentLang = languages.find((l) => l.code === currentCode) || languages[1];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className={`position-relative d-inline-block ${className}`} ref={dropdownRef}>
      <button
        type="button"
        className="btn btn-outline-gray-200 text-gray-700 bg-white rounded-pill px-12 py-6 text-xs fw-bold flex-align gap-6 hover-border-main-600 hover-text-main-600 transition-2 shadow-2xs"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <i className="ph ph-globe text-base text-main-600"></i>
        <span>{currentLang.short}</span>
        <i className="ph ph-caret-down text-2xs text-gray-400"></i>
      </button>

      {isOpen && (
        <div
          className="position-absolute end-0 mt-6 bg-white rounded-12 shadow-lg border border-gray-100 py-6 z-3"
          style={{ minWidth: '130px' }}
        >
          {languages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              className={`dropdown-item w-100 text-start px-12 py-6 text-xs flex-align gap-8 transition-2 ${
                lang.code === currentLang.code
                  ? 'bg-main-50 text-main-600 fw-bold'
                  : 'text-gray-700 hover-bg-gray-50'
              }`}
              onClick={() => handleSelect(lang.code)}
            >
              <span>{lang.flag}</span>
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
